import { createSlice } from "@reduxjs/toolkit";

export const adminsSlice = createSlice({
  name: "admins",
  initialState: {
    list: [],
    meta: {},
  },
  reducers: {
    getStandardAdminsListRequest: () => {},
    getStandardAdminsListResponse: (state, action) => {
      state.list = action.payload?.admins;
      state.meta = action.payload?.meta;
    },
    addStandardAdminRequest: () => {},
    sendResetPasswordEmail: () => {},
  },
});

export const {
  getStandardAdminsListRequest,
  getStandardAdminsListResponse,
  addStandardAdminRequest,
  sendResetPasswordEmail,
} = adminsSlice.actions;
export default adminsSlice.reducer;
